var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{class:_vm.req.language,attrs:{"id":"editor"}},[(_vm.hasMetadata)?_c('div',{attrs:{"id":"metadata"}},[_c('h2',[_vm._v(_vm._s(_vm.$t('files.metadata')))])]):_vm._e(),_vm._v(" "),(_vm.hasMetadata)?_c('h2',[_vm._v(_vm._s(_vm.$t('files.body')))]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03ed0d91","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/files/Editor.vue
// module id = 393
// module chunks = 0